(function($) {

  var $productPop = $('.js-productPop');
  var $qtyDiscoverToggleInput = $('.js-discoverToggle-input');
  var $qtyDiscoverToggleLabel = $('.js-discoverToggle-label');

  $qtyDiscoverToggleInput.change(function() {
    $(this).closest($productPop).find($('.js-discoverToggle-label.open, .js-discoverToggle-label.close')).toggle();
  });


})(jQuery);